import Vue from 'vue'
import VueRouter from 'vue-router'

const Login = () => import('../views/login/Login.vue');

/* 一级管理员 */
/* 系统设置 */
const OneLevelSystemIndex = () => import('../views/one-level/system-settings/index.vue');
const OneLevelStaffDepartmentIndex = () => import('../views/one-level/system-settings/staff-department/index.vue');
const OneLevelFireIndex = () => import('../views/one-level/index.vue');
const OneLevelStaff = () => import('../views/one-level/system-settings/staff-department/Staff.vue');
const OneLevelDepartment = () => import('../views/one-level/system-settings/staff-department/Department.vue');
const OneLevelRoleAuthority = () => import('../views/one-level/system-settings/role-authority.vue');
/* 风险模块 */
const OneRiskModuleIndex = () => import('../views/one-level/risk-module/index.vue');
/* 风险预警 */
const OneRiskWarnIndex = () => import('../views/one-level/risk-module/risk-warn/index.vue');
const OneRiskWarn = () => import('../views/one-level/risk-module/risk-warn/risk-warn.vue');
const OneRiskRelease = () => import('../views/one-level/risk-module/risk-warn/risk-release.vue');
/* 预警发布 */
const OneRiskReleaseIndex = () => import('../views/one-level/risk-module/risk-release/index.vue');
const OneRiskReleaseList = () => import('../views/one-level/risk-module/risk-release/release-list.vue');
const OneRiskReleaseDetails = () => import('../views/one-level/risk-module/risk-release/release-details.vue');
const OneRiskReleaseWarn = () => import('../views/one-level/risk-module/risk-release/Release.vue');
/* 预警总览 */
const OneOverviewIndex = () => import('../views/one-level/risk-module/overview/index.vue');
const OneOverview = () => import('../views/one-level/risk-module/overview/Overview.vue');
const OneTaskRecord = () => import('../views/one-level/risk-module/overview/task-record.vue');

/* 无权限展示的缺省图页面 */
const TwoLevelNoAuthority = () => import('../views/two-level/no-authority/no-authority.vue');

/* 二级管理员 */
const TwoLevelFireIndex = () => import('../views/two-level/index.vue');
/* 系统设置 */
const TwoLevelSystemIndex = () => import('../views/two-level/system-settings/index.vue');
const TwoLevelStaffDepartmentIndex = () => import('../views/two-level/system-settings/staff-department/index.vue');
const TwoLevelStaff = () => import('../views/two-level/system-settings/staff-department/Staff.vue');
const TwoLevelDepartment = () => import('../views/two-level/system-settings/staff-department/Department.vue');
const TwoLevelRoleAuthority = () => import('../views/two-level/system-settings/role-authority.vue');
const TwoLevelModuleAdministrator = () => import('../views/two-level/system-settings/module-administrator.vue');

/* 报销模块 */
const TwoLevelReimbursementModule = () => import('../views/two-level/reimbursement-module/index.vue');
/* 单据查询 */
const TwoLevelBillSearchIndex = () => import('../views/two-level/reimbursement-module/bill-search/index.vue');
const TwoLevelReimbursementSearch = () => import('../views/two-level/reimbursement-module/bill-search/reimbursement-search.vue');
const TwoLevelPreliminarySearch = () => import('../views/two-level/reimbursement-module/bill-search/preliminary-search.vue');
const TwoLevelReimbursementDetails = () => import('../views/two-level/reimbursement-module/bill-search/reimbursement-details.vue');
/* 单据管理 */
const TwoLevelBillAdministrationIndex = () => import('../views/two-level/reimbursement-module/bill-administration/index.vue');
const TwoLevelBillAdministrationReimbursement = () => import('../views/two-level/reimbursement-module/bill-administration/reimbursement.vue');
const TwoLevelBillAdministrationPreliminary = () => import('../views/two-level/reimbursement-module/bill-administration/preliminary.vue');
const TwoLevelBillAdministrationCost = () => import('../views/two-level/reimbursement-module/bill-administration/cost.vue');
/* 审批流程管理 */
const TwoLevelApprovalIndex = () => import('../views/two-level/reimbursement-module/approval/index.vue');
const TwoLevelApprovalReimbursement = () => import('../views/two-level/reimbursement-module/approval/reimbursement.vue');
const TwoLevelApprovalPreliminary = () => import('../views/two-level/reimbursement-module/approval/preliminary.vue');

/* 表单控件 */
const TwoLevelFormIndex = () => import('../views/two-level/form-control/index.vue');
const TwoLevelFormControl = () => import('../views/two-level/form-control/form-control.vue');


/* 伙食模块 */
const FoodModuleIndex = () => import('../views/two-level/food-module/index.vue');
/* 食堂管理 */
const CanteenManagementIndex = () => import('../views/two-level/food-module/canteen-management/index.vue');
const CanteenManagementList = () => import('../views/two-level/food-module/canteen-management/canteen-management-list.vue');
/* 物料管理 */
const MaterialManagementIndex = () => import('../views/two-level/food-module/material-management/index.vue');
const MaterialManagement = () => import('../views/two-level/food-module/material-management/material-management.vue');
/* 菜谱管理 */
const MenuManagementIndex = () => import('../views/two-level/food-module/menu-management/index.vue')
const ThisWeek = () => import('../views/two-level/food-module/menu-management/this-week.vue')
const NextWeek = () => import('../views/two-level/food-module/menu-management/next-week.vue')
/* 供应商管理 */
const SupplerManagementIndex = () => import('../views/two-level/food-module/supplier-managenment/index.vue');
const SupplerManagement = () => import('../views/two-level/food-module/supplier-managenment/supplier-managenment.vue');
/* 采购列表 */
const PurchaseIndex = () => import('../views/two-level/food-module/purchase/index.vue')
const Purchase = () => import('../views/two-level/food-module/purchase/purchase.vue');
const PurchasePrintIndex = () => import('../views/two-level/food-module/purchase/print/index.vue');
const PurchasePrintDailyConsumption = () => import('../views/two-level/food-module/purchase/print/daily-consumption.vue');
/* 一周伙食采购报表 */
const PurchasePrintFoodAccount = () => import('../views/two-level/food-module/purchase/print/food-account.vue');
/* 采购代发票 */
const PurchasePrintSubstituteInvoice = () => import('../views/two-level/food-module/purchase/print/substitute-invoice.vue');
/* 外来人员就餐 */
const OutsidersIndex = () => import('../views/two-level/food-module/outsiders/index.vue')
const Outsiders = () => import('../views/two-level/food-module/outsiders/Outsiders.vue');
/* 库存管理 */
const InventoryIndex = () => import('../views/two-level/food-module/inventory-management/index.vue')
const Inventory = () => import('../views/two-level/food-module/inventory-management/inventory.vue')
const PurchaseRecode = () => import('../views/two-level/food-module/inventory-management/purchase-recode.vue')
const ConsumptionRecord = () => import('../views/two-level/food-module/inventory-management/consumption-record.vue')
/* 帮厨管理 */
const KitchenIndex = () => import('../views/two-level/food-module/kitchen-module/index.vue')
const Kitchen = () => import('../views/two-level/food-module/kitchen-module/kitchen.vue')


/* 固定资产 */
const FixedAssetsIndex = () => import('../views/two-level/fixed-assets/index.vue');
/* 资产列表 */
const AssetsListIndex = () => import('../views/two-level/fixed-assets/assets-list/index.vue');
const AssetsList = () => import('../views/two-level/fixed-assets/assets-list/assets-list.vue');
/* 审批列表 */
const ApprovelRecordIndex = () => import('../views/two-level/fixed-assets/approvel-record/index.vue');
const ApprovelRecord = () => import('../views/two-level/fixed-assets/approvel-record/approvel-record.vue');
/* 资产审批流程 */
const ApprovelIndex = () => import('../views/two-level/fixed-assets/approvel/index.vue');
const ApprovelApplyIndex = () => import('../views/two-level/fixed-assets/approvel/Apply.vue');
const ApprovelTransferIndex = () => import('../views/two-level/fixed-assets/approvel/Transfer.vue');
const ApprovelScrapIndex = () => import('../views/two-level/fixed-assets/approvel/Scrap.vue');
const ApprovelInventoryLossIndex = () => import('../views/two-level/fixed-assets/approvel/inventory-loss.vue');
const ApprovelInventoryGainIndex = () => import('../views/two-level/fixed-assets/approvel/inventory-gain.vue');
const ApprovelAllocationIndex = () => import('../views/two-level/fixed-assets/approvel/Allocation.vue');


/* 工薪模块 */
const SalaryModuleIndex = () => import('../views/two-level/salary-module/index.vue');
/* 工薪审批流程 */
const SalaryModuleIApprovelIndex = () => import('../views/two-level/salary-module/approvel/index.vue');
const SalaryModuleIApprovel = () => import('../views/two-level/salary-module/approvel/approvel.vue');
/* 工薪模板 */
const SalaryTmpIndex = () => import('../views/two-level/salary-module/salary-tmp/index.vue');
const SalaryTmp = () => import('../views/two-level/salary-module/salary-tmp/salary-tmp.vue');
/* 工薪制表 */
const SalaryFormIndex = () => import('../views/two-level/salary-module/salary-form/index.vue');
const SalaryForm = () => import('../views/two-level/salary-module/salary-form/salary-form.vue');
const SalarySend = () => import('../views/two-level/salary-module/salary-form/send-salary.vue');
const AddSalaryForm = () => import('../views/two-level/salary-module/salary-form/AddSalaryForm.vue');


/* 权威模块 */
const AuthoritativeModuleIndex = () => import('../views/two-level/authoritative-module/index.vue');
/* 规制发布编辑 */
const RegulatoryReleaseIndex = () => import('../views/two-level/authoritative-module/regulatory-release/index.vue');
const RegulatoryRelease = () => import('../views/two-level/authoritative-module/regulatory-release/regulatory-release.vue');
/* 档案馆编辑 */
const ArchivesIndex = () => import('../views/two-level/authoritative-module/archives/index.vue');
const Archives = () => import('../views/two-level/authoritative-module/archives/Archives.vue');
const AddRegulatory = () => import('../views/two-level/authoritative-module/archives/add-rule.vue');
/* 疑难解答 */
const TroubleshootingIndex = () => import('../views/two-level/authoritative-module/Troubleshooting/index.vue');
const Troubleshooting = () => import('../views/two-level/authoritative-module/Troubleshooting/Troubleshooting.vue');


/* 财务管理员 */
const FinanceIndex = () => import('../views/finance/index.vue');
/* 报销单---index */
const FinanceReimbursementIndex = () => import('../views/finance/reimbursement-module/index.vue');
/* 待审批列表---index */
const FinanceReimbursementApprovalIndex = () => import('../views/finance/reimbursement-module/approval-list/index.vue');
/* 待审批列表 */
const FinanceReimbursementApproval = () => import('../views/finance/reimbursement-module/approval-list/reimbursement.vue');
const FinanceReimbursementApprovalDetails = () => import('../views/finance/reimbursement-module/approval-list/approval-details.vue');
/* 已审批列表---index */
const FinanceReimbursementFinishApprovalIndex = () => import('../views/finance/reimbursement-module/finish-approval/index.vue');
/* 待审批列表 */
const FinanceReimbursementFinishApproval = () => import('../views/finance/reimbursement-module/finish-approval/finish-approval-list.vue');
const FinanceReimbursementFinishApprovalDetails = () => import('../views/finance/reimbursement-module/finish-approval/finish-approval-details.vue');

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    meta: {
      id: 'loginHome',
      title: "登录页面",
      pageName: '登录页面'
    },
    component: Login
  },
  {
    path: '/formIndex',
    component: TwoLevelFormIndex,
    redirect: '/formIndex/formControl',
    meta: {
      id: 'formIndex',
      pageName: '表单控件入口页面'
    },
    children: [
      {
        path: 'formControl',
        name: 'formControl',
        meta: {
          id: 'formControl',
          pageName: '表单控件'
        },
        component: TwoLevelFormControl
      }
    ]
  },

  /* 一级管理员 */
  {
    path: '/oneLevel',
    component: OneLevelFireIndex,
    redirect: '/oneLevel/systemIndex',
    meta: {
      id: 'oneLevel',
      pageName: '一级管理员入口页面'
    },
    children: [
      {
        path: 'systemIndex',
        name: 'systemIndex',
        component: OneLevelSystemIndex,
        redirect: '/oneLevel/systemIndex/staffDepartmentIndex',
        meta: {
          id: 'systemIndex',
          title: "系统设置",
          pageName: '一级管理员系统设置页面'
        },
        children: [
          {
            path: 'staffDepartmentIndex',
            name: 'staffDepartmentIndex',
            component: OneLevelStaffDepartmentIndex,
            redirect: '/oneLevel/systemIndex/staffDepartmentIndex/staff',
            meta: {
              id: 'staffDepartmentIndex',
              title: "成员与部门",
              pageName: '一级管理员成员与部门页面'
            },
            children: [
              {
                path: 'staff',
                name: 'staff',
                meta: {
                  id: 'staff',
                  title: "成员",
                  pageName: '一级管理员成员页面'
                },
                component: OneLevelStaff,
              },
              {
                path: 'department',
                name: 'department',
                meta: {
                  id: 'department',
                  title: "部门",
                  pageName: '一级管理员部门页面'
                },
                component: OneLevelDepartment,
              }
            ]
          },
          {
            path: 'roleAuthority',
            name: 'roleAuthority',
            component: OneLevelRoleAuthority,
            meta: {
              id: 'roleAuthority',
              title: "系统管理员",
              pageName: '一级管理员系统管理员页面'
            },
          }
        ]
      },
      {
        path: 'riskModuleIndex',
        name: 'riskModuleIndex',
        component: OneRiskModuleIndex,
        redirect: '/oneLevel/riskModuleIndex/riskWarnIndex',
        meta: {
          id: 'riskModuleIndex',
          title: "风险模块",
          pageName: '一级管理员风险模块入口页面'
        },
        children: [
          {
            path: 'riskWarnIndex',
            name: 'riskWarnIndex',
            component: OneRiskWarnIndex,
            redirect: '/oneLevel/riskModuleIndex/riskWarnIndex/riskWarn',
            meta: {
              id: 'riskWarnIndex',
              pageName: '一级管理员风险预警入口页面'
            },
            children: [
              {
                path: 'riskWarn',
                name: 'riskWarn',
                meta: {
                  id: 'riskWarn',
                  title: "风险设置",
                  pageName: '一级管理员风险设置页面'
                },
                component: OneRiskWarn,
              },
              {
                path: 'riskRelease',
                name: 'riskRelease',
                meta: {
                  id: 'riskRelease',
                  title: "发布",
                  pageName: '一级管理员发布页面'
                },
                component: OneRiskRelease,
              },
            ]
          },
          {
            path: 'overviewIndex',
            name: 'overviewIndex',
            component: OneOverviewIndex,
            redirect: '/oneLevel/riskModuleIndex/overviewIndex/overview',
            meta: {
              id: 'overviewIndex',
              pageName: '一级管理员预警总览入口页面'
            },
            children: [
              {
                path: 'overview',
                name: 'overview',
                meta: {
                  id: 'overview',
                  title: "预警总览",
                  pageName: '一级管理员预警总览页面'
                },
                component: OneOverview,
              },
              {
                path: 'taskRecord',
                name: 'taskRecord',
                meta: {
                  id: 'taskRecord',
                  title: "任务记录",
                  pageName: '一级管理员任务记录页面'
                },
                component: OneTaskRecord,
              },
            ]
          },
          {
            path: 'riskReleaseIndex',
            name: 'riskReleaseIndex',
            component: OneRiskReleaseIndex,
            redirect: '/oneLevel/riskModuleIndex/riskReleaseIndex/riskReleaseList',
            meta: {
              id: 'riskReleaseIndex',
              pageName: '一级管理员预警发布入口页面'
            },
            children: [
              {
                path: 'riskReleaseList',
                name: 'riskReleaseList',
                meta: {
                  id: 'riskReleaseList',
                  title: "预警发布",
                  pageName: '一级管理员预警发布页面'
                },
                component: OneRiskReleaseList,
              },
              {
                path: 'riskReleaseDetails',
                name: 'riskReleaseDetails',
                meta: {
                  id: 'riskReleaseDetails',
                  title: "详情",
                  pageName: '一级管理员预警发布详情页面'
                },
                component: OneRiskReleaseDetails,
              },
              {
                path: 'riskReleaseWarn',
                name: 'riskReleaseWarn',
                meta: {
                  id: 'riskReleaseWarn',
                  title: "任务发布",
                  pageName: '一级管理员任务发布页面'
                },
                component: OneRiskReleaseWarn,
              },
            ]
          },
        ]
      },
    ]
  },

  /* 二级管理员 */
  {
    path: '/fire',
    name: 'fire',
    component: TwoLevelFireIndex,
    redirect: '/fire/systemIndex',
    meta: {
      id: 'twoLevelFire',
      pageName: '二级管理员入口页面'
    },
    children: [
      {
        path: 'systemIndex',
        name: 'systemIndex',
        component: TwoLevelSystemIndex,
        redirect: '/fire/systemIndex/staffDepartmentIndex',
        meta: {
          id: 'twoLevelSystemIndex',
          title: "系统设置",
          pageName: '二级管理员系统设置入口页面'
        },
        children: [
          {
            path: 'staffDepartmentIndex',
            name: 'staffDepartmentIndex',
            component: TwoLevelStaffDepartmentIndex,
            redirect: '/fire/systemIndex/staffDepartmentIndex/staff',
            meta: {
              id: 'twoLevelStaffDepartmentIndex',
              title: "成员与部门",
              pageName: '二级管理员成员与部门入口页面'
            },
            children: [
              {
                path: 'staff',
                name: 'staff',
                component: TwoLevelStaff,
                meta: {
                  id: 'twoLevelStaff',
                  title: "成员",
                  pageName: '二级管理员成员页面'
                },
              },
              {
                path: 'department',
                name: 'department',
                component: TwoLevelDepartment,
                meta: {
                  id: 'twoLevelDepartment',
                  title: "部门",
                  pageName: '二级管理员部门页面'
                },
              }
            ]
          },
          {
            path: 'module-administrator',
            name: 'module-administrator',
            component: TwoLevelModuleAdministrator,
            meta: {
              id: 'twoLevelModuleAdministrator',
              title: "模块管理员",
              pageName: '二级管理员模块管理员页面'
            },
          },
          {
            path: 'roleAuthority',
            name: 'roleAuthority',
            component: TwoLevelRoleAuthority,
            meta: {
              id: 'twoLevelRoleAuthority',
              title: "业务角色",
              pageName: '二级管理员业务角色页面'
            },
          }
        ]
      },
      {
        path: 'reimbursementModuleIndex',
        name: 'reimbursementModuleIndex',
        component: TwoLevelReimbursementModule,
        redirect: '/fire/reimbursementModuleIndex/billSearchIndex',
        meta: {
          id: 'twoLevelReimbursementModule',
          title: "报销模块",
          pageName: '二级管理员报销模块入口页面'
        },
        children: [
          {
            path: 'billSearchIndex',
            name: 'billSearchIndex',
            component: TwoLevelBillSearchIndex,
            redirect: '/fire/reimbursementModuleIndex/billSearchIndex/reimbursementSearch',
            meta: {
              id: 'twoLevelBillSearchIndex',
              title: "单据查询",
              pageName: '二级管理员单据查询入口页面'
            },
            children: [
              {
                path: 'reimbursementSearch',
                name: 'reimbursementSearch',
                component: TwoLevelReimbursementSearch,
                meta: {
                  id: 'twoLevelReimbursementSearch',
                  title: "报销单查询",
                  pageName: '二级管理员报销单查询页面'
                },
              },
              // {
              //   path: 'preliminarySearch',
              //   name: 'preliminarySearch',
              //   component: TwoLevelPreliminarySearch,
              //   meta: {
              //     id: 'twoLevelPreliminarySearch',
              //     title: "预审批单查询"
              //     pageName: '二级管理员预审批单查询页面'
              //   },
              // },
              {
                path: 'reimbursementDetails',
                name: 'reimbursementDetails',
                component: TwoLevelReimbursementDetails,
                meta: {
                  id: 'twoLevelReimbursementDetails',
                  title: "报销单查询",
                  pageName: '二级管理员报销单查询详情页面'
                },
              },
            ]
          },
          {
            path: 'billAdministrationIndex',
            name: 'billAdministrationIndex',
            component: TwoLevelBillAdministrationIndex,
            redirect: '/fire/reimbursementModuleIndex/billAdministrationIndex/billAdministrationReimbursement',
            meta: {
              id: 'twoLevelBillAdministrationIndex',
              title: "单据管理",
              pageName: '二级管理员单据管理入口页面'
            },
            children: [
              {
                path: 'billAdministrationReimbursement',
                name: 'billAdministrationReimbursement',
                component: TwoLevelBillAdministrationReimbursement,
                meta: {
                  id: 'twoLevelBillAdministrationReimbursement',
                  title: "报销类型",
                  pageName: '二级管理员报销类型页面'
                },
              },
              // {
              //   path: 'billAdministrationPreliminary',
              //   name: 'billAdministrationPreliminary',
              //   component: TwoLevelBillAdministrationPreliminary,
              //   meta: {
              //     id: 'twoLevelBillAdministrationPreliminary',
              //     title: "预审批类型",
              //     pageName: '二级管理员预审批类型页面'
              //   },
              // },
              {
                path: 'billAdministrationCost',
                name: 'billAdministrationCost',
                component: TwoLevelBillAdministrationCost,
                meta: {
                  id: 'twoLevelBillAdministrationCost',
                  title: "费用类型",
                  pageName: '二级管理员费用类型页面'
                },
              },
            ]
          },
          {
            path: 'approvalIndex',
            name: 'approvalIndex',
            component: TwoLevelApprovalIndex,
            redirect: '/fire/reimbursementModuleIndex/approvalIndex/approvalReimbursement',
            meta: {
              id: 'twoLevelApprovalIndex',
              title: "审批流程管理",
              pageName: '二级管理员审批流程管理入口页面'
            },
            children: [
              {
                path: 'approvalReimbursement',
                name: 'approvalReimbursement',
                component: TwoLevelApprovalReimbursement,
                meta: {
                  id: 'twoLevelApprovalReimbursement',
                  title: "报销单流程",
                  pageName: '二级管理员报销单流程页面'
                },
              },
              // {
              //   path: 'approvalPreliminary',
              //   name: 'approvalPreliminary',
              //   component: TwoLevelApprovalPreliminary,
              //   meta: {
              //     id: 'twoLevelApprovalPreliminary,
              //     title: "预审批单流程",
              //     pageName: '二级管理员预审批单流程页面'
              //   },
              // }
            ]
          },
        ]
      },
      {
        path: 'foodModuleIndex',
        name: 'foodModuleIndex',
        component: FoodModuleIndex,
        redirect: '/fire/foodModuleIndex/canteenManagementIndex',
        meta: {
          id: 'foodModuleIndex',
          title: "伙食模块",
          pageName: '二级管理员伙食模块入口页面'
        },
        children: [
          {
            path: 'canteenManagementIndex',
            name: 'canteenManagementIndex',
            component: CanteenManagementIndex,
            redirect: '/fire/foodModuleIndex/canteenManagementIndex/canteenManagementList',
            meta: {
              id: 'canteenManagementIndex',
              pageName: '二级管理员食堂管理入口页面'
            },
            children: [
              {
                path: 'canteenManagementList',
                name: 'canteenManagementList',
                component: CanteenManagementList,
                meta: {
                  id: 'canteenManagementList',
                  title: "食堂管理",
                  pageName: '二级管理员食堂管理页面'
                },
              }
            ]
          },
          {
            path: 'materialManagementIndex',
            name: 'materialManagementIndex',
            component: MaterialManagementIndex,
            redirect: '/fire/foodModuleIndex/materialManagementIndex/materialManagement',
            meta: {
              id: 'materialManagementIndex',
              title: "物料管理",
              pageName: '二级管理员物料管理入口页面'
            },
            children: [
              {
                path: 'materialManagement',
                name: 'materialManagement',
                component: MaterialManagement,
                meta: {
                  id: 'materialManagement',
                  pageName: '二级管理员物料管理页面'
                },
              }
            ]
          },
          {
            path: 'supplerManagementIndex',
            name: 'supplerManagementIndex',
            component: SupplerManagementIndex,
            redirect: '/fire/foodModuleIndex/supplerManagementIndex/supplerManagement',
            meta: {
              id: 'supplerManagementIndex',
              title: "供应商管理",
              pageName: '二级管理员供应商管理入口页面'
            },
            children: [
              {
                path: 'supplerManagement',
                name: 'supplerManagement',
                component: SupplerManagement,
                meta: {
                  id: 'supplerManagement',
                  pageName: '二级管理员供应商管理页面'
                },
              }
            ]
          },
          {
            path: 'menuManagementIndex',
            name: 'menuManagementIndex',
            component: MenuManagementIndex,
            redirect: '/fire/foodModuleIndex/menuManagementIndex/thisWeek',
            meta: {
              id: 'menuManagementIndex',
              title: "菜谱管理",
              pageName: '二级管理员菜谱管理入口页面'
            },
            children: [
              {
                path: 'thisWeek',
                name: 'thisWeek',
                component: ThisWeek,
                meta: {
                  id: 'thisWeek',
                  title: "本周菜单",
                  pageName: '二级管理员本周菜单页面'
                },
              },
              {
                path: 'nextWeek',
                name: 'nextWeek',
                component: NextWeek,
                meta: {
                  id: 'nextWeek',
                  title: "下周菜单",
                  pageName: '二级管理员下周菜单页面'
                },
              },
            ]
          },
          {
            path: 'purchaseIndex',
            name: 'purchaseIndex',
            component: PurchaseIndex,
            redirect: '/fire/foodModuleIndex/purchaseIndex/purchase',
            meta: {
              id: 'purchaseIndex',
              title: "采购列表",
              pageName: '二级管理员采购列表入口页面'
            },
            children: [
              {
                path: 'purchase',
                name: 'purchase',
                component: Purchase,
                meta: {
                  id: 'purchase',
                  pageName: '二级管理员采购列表页面'
                },
              },
              {
                path: 'printIndex',
                name: 'printIndex',
                component: PurchasePrintIndex,
                redirect: '/fire/foodModuleIndex/purchaseIndex/printIndex/printDailyConsumption',
                meta: {
                  id: 'printIndex',
                  pageName: '二级管理员打印入口页面'
                },
                children: [
                  {

                    path: 'printDailyConsumption',
                    name: 'printDailyConsumption',
                    component: PurchasePrintDailyConsumption,
                    meta: {
                      id: 'printDailyConsumption',
                      pageName: '二级管理员打印页面'
                    },
                  },
                  {
                    path: 'printFoodAccount',
                    name: 'printFoodAccount',
                    component: PurchasePrintFoodAccount,
                    meta: {
                      id: 'printFoodAccount',
                      pageName: '二级管理员一周伙食采购报表页面'
                    },
                  },
                  {
                    path: 'printSubstituteInvoice',
                    name: 'printSubstituteInvoice',
                    component: PurchasePrintSubstituteInvoice,
                    meta: {
                      id: 'printSubstituteInvoice',
                      pageName: '二级管理员采购代发票页面'
                    },
                  }
                ]
              }
            ]
          },
          {
            path: 'outsidersIndex',
            name: 'outsidersIndex',
            component: OutsidersIndex,
            redirect: '/fire/foodModuleIndex/outsidersIndex/outsiders',
            meta: {
              id: 'outsidersIndex',
              title: "外来人员就餐",
              pageName: '二级管理员外来人员就餐入口页面'
            },
            children: [
              {
                path: 'outsiders',
                name: 'outsiders',
                component: Outsiders,
                meta: {
                  id: 'outsiders',
                  pageName: '二级管理员外来人员就餐页面'
                },
              }
            ]
          },
          {
            path: 'inventoryIndex',
            name: 'inventoryIndex',
            component: InventoryIndex,
            redirect: '/fire/foodModuleIndex/inventoryIndex/inventory',
            meta: {
              id: 'inventoryIndex',
              title: "库存管理",
              pageName: '二级管理员库存管理入口页面'
            },
            children: [
              {
                path: 'inventory',
                name: 'inventory',
                component: Inventory,
                meta: {
                  id: 'inventory',
                  title: "当前库存",
                  pageName: '二级管理员当前库存页面'
                },
              },
              {
                path: 'purchaseRecode',
                name: 'purchaseRecode',
                component: PurchaseRecode,
                meta: {
                  id: 'purchaseRecode',
                  title: "采购记录",
                  pageName: '二级管理员采购记录页面'
                },
              },
              {
                path: 'consumptionRecord',
                name: 'consumptionRecord',
                component: ConsumptionRecord,
                meta: {
                  id: 'consumptionRecord',
                  title: "消耗记录",
                  pageName: '二级管理员消耗记录页面'
                },
              },
            ]
          },
          {
            path: 'kitchenIndex',
            name: 'kitchenIndex',
            component: KitchenIndex,
            redirect: '/fire/foodModuleIndex/kitchenIndex/kitchen',
            meta: {
              id: 'kitchenIndex',
              title: "",
              pageName: '二级管理员帮厨管理入口页面'
            },
            children: [
              {
                path: 'kitchen',
                name: 'kitchen',
                component: Kitchen,
                meta: {
                  id: 'kitchen',
                  title: "帮厨设置",
                  pageName: '二级管理员帮厨设置页面'
                },
              }
            ]
          },
        ]
      },
      {
        path: 'fixedAssetsIndex',
        name: 'fixedAssetsIndex',
        component: FixedAssetsIndex,
        redirect: '/fire/fixedAssetsIndex/assetsListIndex',
        meta: {
          id: 'fixedAssetsIndex',
          title: "资产模块",
          pageName: '二级管理员资产模块入口页面'
        },
        children: [
          {
            path: 'assetsListIndex',
            name: 'assetsListIndex',
            component: AssetsListIndex,
            redirect: '/fire/fixedAssetsIndex/assetsListIndex/assetsList',
            meta: {
              id: 'assetsListIndex',
              pageName: '二级管理员资产列表入口页面'
            },
            children: [
              {
                path: 'assetsList',
                name: 'assetsList',
                component: AssetsList,
                meta: {
                  id: 'assetsList',
                  title: "资产列表",
                  pageName: '二级管理员资产列表页面'
                },
              }
            ]
          },
          {
            path: 'approvelRecordIndex',
            name: 'approvelRecordIndex',
            component: ApprovelRecordIndex,
            redirect: '/fire/fixedAssetsIndex/approvelRecordIndex/approvelRecord',
            meta: {
              id: 'approvelRecordIndex',
              pageName: '二级管理员审批列表入口页面'
            },
            children: [
              {
                path: 'approvelRecord',
                name: 'approvelRecord',
                component: ApprovelRecord,
                meta: {
                  id: 'approvelRecord',
                  title: "审批记录",
                  pageName: '二级管理员审批记录页面'
                },
              }
            ]
          },
          {
            path: 'approvelIndex',
            name: 'approvelIndex',
            component: ApprovelIndex,
            redirect: '/fire/fixedAssetsIndex/approvelIndex/approvelApplyIndex',
            meta: {
              id: 'approvelIndex',
              title: "审批流程管理",
              pageName: '二级管理员审批流程管理入口页面'
            },
            children: [
              {
                path: 'approvelApplyIndex',
                name: 'approvelApplyIndex',
                component: ApprovelApplyIndex,
                meta: {
                  id: 'approvelApplyIndex',
                  title: "申请流程",
                  pageName: '二级管理员申请流程入口页面'
                },
              },
              {
                path: 'approvelTransferIndex',
                name: 'approvelTransferIndex',
                component: ApprovelTransferIndex,
                meta: {
                  id: 'approvelTransferIndex',
                  title: "移交流程",
                  pageName: '二级管理员移交流程入口页面'
                },
              },
              {
                path: 'approvelScrapIndex',
                name: 'approvelScrapIndex',
                component: ApprovelScrapIndex,
                meta: {
                  id: 'approvelScrapIndex',
                  title: "报废流程",
                  pageName: '二级管理员报废流程入口页面'
                },
              },
              {
                path: 'approvelInventoryLossIndex',
                name: 'approvelInventoryLossIndex',
                component: ApprovelInventoryLossIndex,
                meta: {
                  id: 'approvelInventoryLossIndex',
                  title: "盘亏流程",
                  pageName: '二级管理员盘亏流程入口页面'
                },
              },
              {
                path: 'approvelInventoryGainIndex',
                name: 'approvelInventoryGainIndex',
                component: ApprovelInventoryGainIndex,
                meta: {
                  id: 'approvelInventoryGainIndex',
                  title: "盘盈流程",
                  pageName: '二级管理员盘盈流程入口页面'
                },
              },
              {
                path: 'approvelAllocationIndex',
                name: 'approvelAllocationIndex',
                component: ApprovelAllocationIndex,
                meta: {
                  id: 'approvelAllocationIndex',
                  title: "调拨流程",
                  pageName: '二级管理员调拨流程入口页面'
                },
              }
            ]
          },
        ]
      },
      {
        path: 'salaryModuleIndex',
        name: 'salaryModuleIndex',
        component: SalaryModuleIndex,
        redirect: '/fire/salaryModuleIndex/salaryModuleIApprovelIndex',
        meta: {
          id: 'salaryModuleIndex',
          title: "工薪模块",
          pageName: '二级管理员工薪模块入口页面'
        },
        children: [
          {
            path: 'salaryModuleIApprovelIndex',
            name: 'salaryModuleIApprovelIndex',
            component: SalaryModuleIApprovelIndex,
            redirect: '/fire/salaryModuleIndex/salaryModuleIApprovelIndex/salaryModuleIApprovel',
            meta: {
              id: 'salaryModuleIApprovelIndex',
              pageName: '二级管理员工薪审批流程入口页面'
            },
            children: [
              {
                path: 'salaryModuleIApprovel',
                name: 'salaryModuleIApprovel',
                component: SalaryModuleIApprovel,
                meta: {
                  id: 'salaryModuleIApprovel',
                  title: "审批流程管理",
                  pageName: '二级管理员工薪审批流程管理页面'
                },
              }
            ]
          },
          {
            path: 'salaryTmpIndex',
            name: 'salaryTmpIndex',
            component: SalaryTmpIndex,
            redirect: '/fire/salaryModuleIndex/salaryTmpIndex/salaryTmp',
            meta: {
              id: 'salaryTmpIndex',
              pageName: '二级管理员工薪模板入口页面'
            },
            children: [
              {
                path: 'salaryTmp',
                name: 'salaryTmp',
                component: SalaryTmp,
                meta: {
                  id: 'salaryTmp',
                  title: "工薪模板",
                  pageName: '二级管理员工薪模板页面'
                },
              }
            ]
          },
          {
            path: 'salaryFormIndex',
            name: 'salaryFormIndex',
            component: SalaryFormIndex,
            redirect: '/fire/salaryModuleIndex/salaryFormIndex/salaryForm',
            meta: {
              id: 'salaryFormIndex',
              pageName: '二级管理员工薪制表入口页面'
            },
            children: [
              {
                path: 'salaryForm',
                name: 'salaryForm',
                component: SalaryForm,
                meta: {
                  id: 'salaryForm',
                  title: "工薪制表",
                  pageName: '二级管理员工薪制表页面'
                },
              },
              {
                path: 'salarySend',
                name: 'salarySend',
                component: SalarySend,
                meta: {
                  id: 'salarySend',
                  title: "工薪制表",
                  pageName: '二级管理员工薪制表发送页面'
                },
              },
              {
                path: 'addSalaryForm',
                name: 'addSalaryForm',
                component: AddSalaryForm,
                meta: {
                  id: 'addSalaryForm',
                  title: "工薪制表",
                  pageName: '二级管理员新增工薪制表页面'
                },
              },
            ]
          }
        ]
      },
      {
        path: 'authoritativeModuleIndex',
        name: 'authoritativeModuleIndex',
        component: AuthoritativeModuleIndex,
        redirect: '/fire/authoritativeModuleIndex/regulatoryReleaseIndex',
        meta: {
          id: 'authoritativeModuleIndex',
          title: "权威发布模块",
          pageName: '二级管理员权威发布模块入口页面'
        },
        children: [
          {
            path: 'regulatoryReleaseIndex',
            name: 'regulatoryReleaseIndex',
            component: RegulatoryReleaseIndex,
            redirect: '/fire/authoritativeModuleIndex/regulatoryReleaseIndex/regulatoryRelease',
            meta: {
              id: 'regulatoryReleaseIndex',
              title: "规制发布编辑",
              pageName: '二级管理员规制发布编辑入口页面'
            },
            children: [
              {
                path: 'regulatoryRelease',
                name: 'regulatoryRelease',
                component: RegulatoryRelease,
                meta: {
                  id: 'regulatoryRelease',
                  pageName: '二级管理员规制发布编辑页面'
                },
              }
            ]
          },
          {
            path: 'archivesIndex',
            name: 'archivesIndex',
            component: ArchivesIndex,
            redirect: '/fire/authoritativeModuleIndex/archivesIndex/archives',
            meta: {
              id: 'archivesIndex',
              title: "规制档案馆",
              pageName: '二级管理员规制档案馆入口页面'
            },
            children: [
              {
                path: 'archives',
                name: 'archives',
                component: Archives,
                meta: {
                  id: 'archives',
                  pageName: '二级管理员规制档案馆页面'
                },
              },
              {
                path: 'add-regulatory',
                name: 'add-regulatory',
                component: AddRegulatory,
                meta: {
                  id: 'addRegulatory',
                  title: "新增规制",
                  pageName: '二级管理员新增规制页面'
                },
              }
            ]
          },
          {
            path: 'troubleshootingIndex',
            name: 'troubleshootingIndex',
            component: TroubleshootingIndex,
            redirect: '/fire/authoritativeModuleIndex/troubleshootingIndex/troubleshooting',
            meta: {
              id: 'troubleshootingIndex',
              title: "疑难解答",
              pageName: '二级管理员疑难解答入口页面'
            },
            children: [
              {
                path: 'troubleshooting',
                name: 'troubleshooting',
                component: Troubleshooting,
                meta: {
                  id: 'troubleshooting',
                  pageName: '二级管理员疑难解答页面'
                },
              },
            ]
          }
        ]
      },
      {
        path: 'noAuthority',
        component: TwoLevelNoAuthority,
        meta: {
          id: 'noAuthority',
          pageName: '二级管理员无权限页面'
        }
      },
    ]
  },

  /* 财务人员 */
  {
    path: '/finance',
    component: FinanceIndex,
    redirect: '/finance/reimbursementIndex',
    meta: {
      id: 'financeIndex',
      pageName: '财务管理员入口页面'
    },
    children: [
      {
        path: 'reimbursementIndex',
        name: 'reimbursementIndex',
        component: FinanceReimbursementIndex,
        redirect: '/finance/reimbursementIndex/approvalIndex',
        meta: {
          id: 'financeReimbursementIndex',
          pageName: '财务管理员报销单入口页面'
        },
        children: [
          {
            path: 'approvalIndex',
            name: 'approvalIndex',
            component: FinanceReimbursementApprovalIndex,
            redirect: '/finance/reimbursementIndex/approvalIndex/approval',
            meta: {
              id: 'financeReimbursementApprovalIndex',
              title: "待审批列表",
              pageName: '财务管理员待审批列表入口页面'
            },
            children: [
              {
                path: 'approval',
                name: 'approval',
                component: FinanceReimbursementApproval,
                meta: {
                  id: 'financeReimbursementApproval',
                  title: "报销单",
                  keepAlive: true,
                  pageName: '财务管理员报销单审批页面'
                },
              },
              {
                path: 'approvalDetails',
                name: 'approvalDetails',
                component: FinanceReimbursementApprovalDetails,
                meta: {
                  id: 'financeReimbursementApprovalDetails',
                  title: "详情",
                  pageName: '财务管理员报销单审批详情页面'
                },
              }
            ]
          },
          {
            path: 'finishApprovalIndex',
            name: 'finishApprovalIndex',
            component: FinanceReimbursementFinishApprovalIndex,
            redirect: '/finance/reimbursementIndex/finishApprovalIndex/finishApproval',
            meta: {
              id: 'financeReimbursementFinishApprovalIndex',
              title: "已审批列表",
              pageName: '财务管理员已审批列表入口页面'
            },
            children: [
              {
                path: 'finishApproval',
                name: 'finishApproval',
                component: FinanceReimbursementFinishApproval,
                meta: {
                  id: 'financeReimbursementFinishApproval',
                  title: "报销单",
                  keepAlive: true,
                  pageName: '财务管理员已审批报销单页面'
                },
              },
              {
                path: 'finishApprovalDetails',
                name: 'finishApprovalDetails',
                component: FinanceReimbursementFinishApprovalDetails,
                meta: {
                  id: 'financeReimbursementFinishApprovalDetails',
                  title: "详情",
                  pageName: '财务管理员已审批报销单详情页面'
                },
              }
            ]
          }
        ]
      },
    ]
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
